import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  FormControl,
} from '@material-ui/core';

import TagDownshift from '../../forms/TagDownshift';
import styles from './styles';

export const getDefaultStateForProps = (tags) => ({
  updatedTags: tags,
  tagInputValue: '',
});

export class EditEventTagsComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = getDefaultStateForProps(props.selectedTags);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedTags && prevProps.selectedTags !== this.props.selectedTags) {
      this.setState(getDefaultStateForProps(this.props.selectedTags));
    }
  }

  handleChangeTag = (selectedItem) => {
    if (this.state.updatedTags.filter((tag) => tag.id === selectedItem.id).length > 0) {
      this.removeSelectedTagItem(selectedItem);
    } else {
      this.addSelectedTagItem(selectedItem);
    }
  }

  addSelectedTagItem = (item) => {
    this.setState((prevState) => ({
      updatedTags: prevState.updatedTags.concat(item),
      tagInputValue: '',
    }), () => {
      this.props.onUpdate(this.state.updatedTags);
    });
  }

  removeSelectedTagItem = (item) => {
    this.setState((prevState) => ({
      updatedTags: prevState.updatedTags.filter((tag) => tag.id !== item.id),
      tagInputValue: '',
    }), () => {
      this.props.onUpdate(this.state.updatedTags);
    });
  }

  handleChangeTagInput = (inputVal) => {
    this.setState({ tagInputValue: inputVal || '' });
  }

  render() {
    const {
      classes,
      tags,
      selectedTags,
      tagTypes,
      isAdmin,
    } = this.props;
    const {
      tagInputValue,
      updatedTags,
    } = this.state;

    return (
      <FormControl
        fullWidth
        className={classes.container}
        variant="outlined"
      >
        <TagDownshift
          onInputValueChange={this.handleChangeTagInput}
          inputValue={tagInputValue}
          availableItems={tags}
          selectedItem={updatedTags || selectedTags}
          onChange={this.handleChangeTag}
          onRemoveItem={this.removeSelectedTagItem}
          itemToString={(tag) => tag.name}
          tagTypes={tagTypes}
          readonly={false}
          isAdmin={isAdmin}
        />
      </FormControl>
    );
  }
}

EditEventTagsComponent.propTypes = {
  classes: PropTypes.object,
  onUpdate: PropTypes.func,
  tags: PropTypes.array,
  selectedTags: PropTypes.array,
  tagTypes: PropTypes.array,
  isAdmin: PropTypes.bool,
};

EditEventTagsComponent.defaultProps = {
  classes: {},
  onUpdate: () => {},
  tags: [],
  selectedTags: [],
  tagTypes: [],
  isAdmin: false,
};

export default (withStyles(styles, { withTheme: true })(EditEventTagsComponent));
